module.exports = __webpack_public_path__ + "img/halon.4830f306.png";